import DashboardsList from './DashboardsList';

export default DashboardsList;
